import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { getCargos, getRepresentacion } from "../../../../../../redux/actions/empleador";
import { validarCuilCuit } from "../../../../../../util/cuilcuit";
import FormikActions from "../../../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../../../commons/formik/FormikAutocomplete";
import FormikTextField from "../../../../../commons/formik/FormikTextField";
import CircularLoading from "../../../../../commons/loading/CircularLoading";
import ResponsablesEnum from "../../../../../enums/responsablesEnum";

const defaultInitialValues = {
    apellidoNombre: "",
    cuit: "",
    representacion: null,
    propio: "",
};

const validationSchema = Yup.object({
    apellidoNombre: Yup.string()
        .max(100, "Máximo 100 caracteres")
        .required("Campo obligatorio"),
    cuit: Yup.string()
        .matches(/^\d{11}$/, "El CUIL/CUIT debe contener 11 dígitos numéricos")
        .required("Campo obligatorio")
        .test({
            name: "cuitValido",
            message: "Debe ingresar un CUIT/CUIL válido",
            test: (value) => (value ? validarCuilCuit(value, true) : false),
        }),
    representacion: Yup.number()
        .required("Campo obligatorio")
        .typeError("Campo obligatorio"),
    propio: Yup.string().required("Debe seleccionar Interno o Externo"),
});

const Res81ResponsableDatosDialog = ({ open, handleClose, handleSubmit, initialValues: propInitialValues, isEditing, loading = false }) => {
    const dispatch = useDispatch();
    const [cargoIdFromDispatch, setCargoIdFromDispatch] = useState(null);
    const representacion = useSelector((state) => state.empleador.representacion);

    useEffect(() => {
        if (open) {

            dispatch(getCargos(ResponsablesEnum.representanteEmpleador))
                .then((res) => {
                    let cargo = res?.value?.data;
                    if (cargo && cargo.length > 0) {
                        setCargoIdFromDispatch(cargo[0].id);
                    }
                })
        }
    }, [dispatch, open]);

    const getInitialValues = () => {
        if (propInitialValues && isEditing) {
            return {
                apellidoNombre: (propInitialValues.nombreCompleto || "").replace(",", "").trim(),
                cuit: (propInitialValues.cuit || "").replace(/[-\s]/g, ""),
                representacion: propInitialValues.representacion || null,
                propio: propInitialValues.propio ? "interno" : "externo",
            };
        }
        return defaultInitialValues;
    };

    const onSubmit = (values) => {
        const [apellido, ...nombresArr] = (values.apellidoNombre || "").split(" ");
        handleSubmit({
            cargoEmpresa: cargoIdFromDispatch,
            responsableDatos: true,
            apellido: apellido || "",
            nombres: nombresArr.join(" ") || "",
            cuit: values.cuit,
            representacion: values.representacion,
            propio: values.propio === "interno",
        });
    };

    return (
        <Dialog open={open} fullWidth maxWidth="sm">
            <DialogTitle>{isEditing ? "Editar Responsable de Datos" : "Agregar Responsable de Datos"}</DialogTitle>
            <Formik
                initialValues={getInitialValues()}
                enableReinitialize
                onSubmit={onSubmit}
                validationSchema={validationSchema}
            >
                {({ values, setFieldValue, errors, touched }) => (
                    <Form>
                        <DialogContent>
                            {loading ? (
                                <CircularLoading />
                            ) : (
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <FormikTextField
                                            name="apellidoNombre"
                                            label="Apellido y Nombre *"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormikTextField
                                            name="cuit"
                                            label="CUIL o CUIT *"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormikAutocomplete
                                            name="representacion"
                                            label="Representación *"
                                            options={representacion.data}
                                            renderOption={(option) => option.nombre}
                                            filterOptions={(option) => option.nombre}
                                            getOptions={() => dispatch(getRepresentacion())}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl
                                            error={touched.propio && Boolean(errors.propio)}
                                            sx={{ flexDirection: "row", alignItems: "center", gap: 2 }}
                                        >
                                            <FormLabel sx={{ mb: 0 }}>Contacto *</FormLabel>
                                            <RadioGroup
                                                row
                                                value={values.propio}
                                                onChange={(e) =>
                                                    setFieldValue("propio", e.target.value)
                                                }
                                            >
                                                <FormControlLabel
                                                    value="interno"
                                                    control={<Radio />}
                                                    label="Interno"
                                                />
                                                <FormControlLabel
                                                    value="externo"
                                                    control={<Radio />}
                                                    label="Externo"
                                                />
                                            </RadioGroup>
                                            {touched.propio && errors.propio && (
                                                <FormHelperText>{errors.propio}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <FormikActions
                                handleCancel={handleClose}
                                loading={loading}
                            />
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default Res81ResponsableDatosDialog;
